module.exports = __webpack_public_path__ + "img/404@2x.aa21a7a5.png";